'use client';

import type { projectControllerButtonVariants } from 'widgets/instance-controller/ui/project-controller-buttons';
import { ProjectControllerButtons } from 'widgets/instance-controller/ui/project-controller-buttons';
import { projectScale, reRunProject, stopBuild } from '@/enteties/project/api';
import type { Project } from '@/enteties/project/modal';
import type { VariantProps } from 'class-variance-authority';
export interface ProjectControlProps extends VariantProps<typeof projectControllerButtonVariants> {
  slug: string;
  project: Project;
}
export const InstanceController = ({
  slug,
  project,
  version
}: ProjectControlProps) => {
  return <>
      <ProjectControllerButtons project={project} slug={slug} mutationOptions={projectScale.getScaleProjectMutationOptions({
      slug
    })} version={version} data-sentry-element="ProjectControllerButtons" data-sentry-source-file="instance-controller.tsx">
        <ProjectControllerButtons.Instances data-sentry-element="unknown" data-sentry-source-file="instance-controller.tsx" />
        <ProjectControllerButtons.StartStop stopBuildMutationOptions={stopBuild.getStopBuildMutationOptions({
        slug
      })} data-sentry-element="unknown" data-sentry-source-file="instance-controller.tsx" />
        <ProjectControllerButtons.BuildProject data-sentry-element="unknown" data-sentry-source-file="instance-controller.tsx" />
        <ProjectControllerButtons.RerunProject mutationOptions={reRunProject.getReRunProjectMutationOptions({
        slug
      })} data-sentry-element="unknown" data-sentry-source-file="instance-controller.tsx" />
      </ProjectControllerButtons>
    </>;
};